// import { DASHBOARD_URL } from '../../constants'
import "./style.scss"

import { Link } from "gatsby"
import React, { useCallback, useEffect, useRef, useState } from "react"
import { logoutUser } from "tf-checkout-react"

import Logo from "../../assets/images/tfsports/main-logo.png"
import { ENV } from "../../constants/env"
import { deleteCookieByName, getCookieByName } from "../../utils/cookies"

export const X_TF_ECOMMERCE = "X-TF-ECOMMERCE"

const Header = ({ setShowLogin, isLogged, setIsLogged }) => {
  const [isNavExpanded, setIsNavExpanded] = useState(false)
  const [showCopiedNotification, setShowCopiedNotification] = useState(false)

  const isWindowDefined = useRef(typeof window !== "undefined")

  const onLogoutSuccess = () => {
    if (isWindowDefined.current) {
      window.localStorage.removeItem("user_data")
      window.location.href = "/"
      deleteCookieByName(X_TF_ECOMMERCE)
    }
  }

  const handleLogout = async () => {
    await logoutUser({ onLogoutSuccess, setIsLogged })
  }

  const handleCopyEmail = async () => {
    if (isWindowDefined.current) {
      try {
        await navigator.clipboard.writeText(ENV.HELP_EMAIL)
        setShowCopiedNotification(true)
        setTimeout(() => {
          setShowCopiedNotification(false)
        }, 2000)
      } catch (err) {
        console.error("Failed to copy email:", err)
      }
    }
  }

  const handleLogin = useCallback(
    e => {
      switch (e?.type) {
        case "tf-login":
          setIsLogged(true)
          break
        case "tf-logout":
          setIsLogged(false)
          break
        default:
          break
      }
    },
    [setIsLogged]
  )

  useEffect(() => {
    const xTfEcommerce = getCookieByName(X_TF_ECOMMERCE)

    if (!isLogged && xTfEcommerce) {
      setIsLogged(true)
    }
  }, [isLogged, setIsLogged])

  useEffect(() => {
    if (isWindowDefined.current) {
      window.document.addEventListener("tf-login", handleLogin)
      return () => {
        window.document.removeEventListener("tf-login", handleLogin)
      }
    }
  }, [handleLogin])

  useEffect(() => {
    if (isWindowDefined.current) {
      window.document.addEventListener("tf-logout", handleLogin)
      return () => {
        window.document.removeEventListener("tf-logout", handleLogin)
      }
    }
  }, [handleLogin])

  useEffect(() => {
    const body = document.querySelector("body")
    if (isNavExpanded) {
      body.style.overflow = "hidden"
    } else {
      body.style.overflow = "visible"
    }
  }, [isNavExpanded])

  return (
    <div className="header">
      <div className="header-container">
        <div className="logo-container">
          <Link to="/">
            <img src={Logo} alt="No Data" height={58} width="100%" />
          </Link>
        </div>
        <nav className="nav">
          <div className={isNavExpanded ? "nav-menu expanded" : "nav-menu"}>
            <button
              type="button"
              className="hamburger"
              onClick={() => {
                setIsNavExpanded(!isNavExpanded)
              }}
            >
              {isNavExpanded ? (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="black"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <line x1="18" y1="6" x2="6" y2="18" />
                  <line x1="6" y1="6" x2="18" y2="18" />
                </svg>
              ) : (
                <svg viewBox="0 0 100 80" width="80" height="20">
                  <rect width="80" height="10" rx="8" />
                  <rect y="30" width="80" height="10" rx="8" />
                  <rect y="60" width="80" height="10" rx="8" />
                </svg>
              )}
            </button>
            <ul>
              <li>
                <button type="button" className="nav-button" onClick={handleCopyEmail}>
                  Contact {ENV.HELP_EMAIL}
                  {showCopiedNotification && <span className="copied-notification">Email copied</span>}
                </button>
              </li>
              {isLogged ? (
                <>
                  <li>
                    <Link className="nav-button" to="/orders">
                      My Tickets
                    </Link>
                  </li>
                  <li>
                    <button type="button" className="nav-button" onClick={handleLogout}>
                      Log out
                    </button>
                  </li>
                </>
              ) : (
                <li>
                  <div className="nav-button">
                    <button
                      type="button"
                      onClick={() => {
                        setShowLogin(true)
                        setIsNavExpanded(false)
                      }}
                    >
                      Login
                    </button>
                  </div>
                </li>
              )}
            </ul>
          </div>
        </nav>
      </div>
    </div>
  )
}

export default Header
